import { L10n } from '../L10n/L10n';
import { IDataSourceInfo } from '../models/IDataSourceInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { CreateExtractTasksAction, ICreateExtractTasksScope } from '../services/CreateExtractTasksAction';

interface CreateDatasourceExtractRefreshScope extends ICreateExtractTasksScope {
  datasource: IDataSourceInfo;
  allowedMode: string;
}

Module.instance().directive('tbDatasourceExtractRefreshScheduler',
  [ '$translate',
    'CreateExtractTasksAction',

    ($translate: ng.translate.ITranslateService,
     CreateExtractTasksAction: CreateExtractTasksAction) => {
      return {
        restrict: 'E',
        replace: true,
        scope: {
          datasource: '=',
          allowedMode: '@',
          extractTask: '='
        },
        templateUrl: 'confirmActionDialogExtractRefresh.html',
        link: (scope:CreateDatasourceExtractRefreshScope) => {
          const schedulePrompt = $translate.instant('schedulesLabelPromptDatasource', { DATASOURCE_NAME: L10n.elideIfLong(scope.datasource.name) });

          const refreshNowPrompt =
            $translate.instant('extractTasksRefreshNowOnDatasourcesPrompt', {
              DATASOURCE_COUNT: 1,
              DATASOURCE_NAME: L10n.elideIfLong(scope.datasource.name)
            }, L10n.Interpolations.Count);

          const datasourceSet = Set.singleton(scope.datasource, (ds: IDataSourceInfo) => ds.id);

          CreateExtractTasksAction.populateScope(scope, datasourceSet, schedulePrompt, parseInt(scope.allowedMode, 10), refreshNowPrompt);
        }
      };
    }
  ]
);
